export const SITE = {
  url: "https://www.mobilestudio.dev",
  name: "Konstantinos Efkarpidis",
  title: "Konstantinos Efkarpidis — Mobile Developer · React Native/Expo",
  description:
    "Mobile developer with 6+ years of experience building React Native and Expo apps with a focus on UI, animation, and performance.",
  shareDescription:
    "I build mobile apps that feel fast, intentional, and human. 6+ years of React Native and Expo experience, from product thinking to App Store/Play Store release.",
  email: "konstantinos.efkarpidis@outlook.com",
  linkedin: "https://www.linkedin.com/in/konstantinos-efkarpidis/",
  github: "https://github.com/kostas64",
  githubRepo: "https://github.com/kostas64/react-native-animated-components",
  githubRepoName: "kostas64/react-native-animated-components",
  ogImage: "https://www.mobilestudio.dev/og-image.png",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt:
    "Konstantinos Efkarpidis — Mobile Developer specializing in React Native and Expo",
};

export type AppInfo = {
  slug: string;
  name: string;
  tagline: string;
  category: string;
  description: string;
  appStoreUrl: string;
  playStoreUrl?: string;
  icon: string;
  accentA: string;
  accentB: string;
};

export const SHOPLIST: AppInfo = {
  slug: "shoplist",
  name: "ShopList",
  tagline: "Shared lists that keep everyone in sync.",
  category: "Productivity · Lists & Planning",
  description:
    "A grocery and shopping list app for shared planning, with real-time collaboration, offline support, budgets, and smart suggestions.",
  appStoreUrl:
    "https://apps.apple.com/gr/app/shoplist-grocery-list-todo/id6744070581",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.kostas_64.ShopList.sync",
  icon: require("../assets/icon.png"),
  accentA: "#4aa8ff",
  accentB: "#8a4fff",
};

export const STACK_CLASH: AppInfo = {
  slug: "stack-clash",
  name: "Stack Clash",
  tagline: "One tap. Perfect timing. Build high.",
  category: "Games · Casual Arcade",
  description:
    "A minimalist stacking game built on timing, streaks, haptics, and the urge to beat your own high score.",
  appStoreUrl:
    "https://apps.apple.com/gr/app/stack-clash-build-high/id6754847803",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.kostas_64.stackclash",
  icon: require("../assets/transparent_icon.png"),
  accentA: "#ff9f1c",
  accentB: "#ff3d8b",
};
